const config = {
  API_URL: 'https://test-api.getsling.com/',
  APP_URL: 'https://test-app.getsling.com/',
  AUTHORIZATION_COOKIE: 'dev:authorization-token',
  INTEGRATIONS_URL: 'https://test-integrations.getsling.com/',
  LOGIN_PAGE_URL: 'https://dev-login.getsling.com',
  TOAST_SLING_CONNECT_URL:
    'https://preprod.eng.toasttab.com/restaurants/admin/scheduling/sling/connect',
};
export default config;
